import {
  PT_GROCERY_PRODUCT_LIST,
  PT_GROCERY_CATEGORY,
  PT_GROCERY_PRODUCT,
} from "./paths/pt-grocery";
import { RTGroceryCategory, RTGroceryProduct, RTGroceryProductList } from "../screens/sc-grocery";
import { KEY_GENERATOR } from "../../functions/funtion";
import { Route } from "react-router-dom";

let RouteArray = [
  [
    <Route
      key={KEY_GENERATOR()}
      path={PT_GROCERY_CATEGORY}
      element={<RTGroceryCategory />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_GROCERY_PRODUCT_LIST}
      element={<RTGroceryProductList />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_GROCERY_PRODUCT}
      element={<RTGroceryProduct />}
    />,
  ],
];

export default RouteArray;
